import { AdminAxiosInstance } from '@nv/services'

export const AdminInstantMeetingService = {
  createEvent: async (eventData) => {
    try {
      const updatedEvent = await AdminAxiosInstance.post(`/events/`, eventData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return { updatedEvent, success: true }
    } catch (error) {
      /* empty */
    }
  },
  updateInstantMeetingEvent: async (eventId, eventData) => {
    try {
      const updatedEvent = await AdminAxiosInstance.put(`/events/${eventId}`, eventData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      return { updatedEvent, success: true }
    } catch (error) {
      /* empty */
    }
  },

  cloneEvent: async (eventId, eventData) => {
    const clonedEvent = await AdminAxiosInstance.post(`/events/${eventId}/clone`, eventData)
    return { clonedEvent }
  },

  deleteEvent: async (eventId) => {
    const deletedEvent = await AdminAxiosInstance.delete(`/events/${eventId}`)
    return { deletedEvent }
  },

  shareVotingLink: async ({ shareWithElectors, emailAddresses, eventId }) => {
    const response = await AdminAxiosInstance.post(`/events/${eventId}/share`, {
      shareWithElectors,
      emailAddresses,
    })
    return { response }
  },

  getQuestionTypes: async () => {
    try {
      const questionTypes = await AdminAxiosInstance.get(`/events/questionTypes`)
      return { questionTypes }
    } catch (error) {
      /* empty */
    }
  },

  addQuestion: async (eventId, questionData) => {
    try {
      const response = await AdminAxiosInstance.post(`/events/${eventId}/questions`, questionData)
      return { response }
    } catch (error) {
      /* empty */
    }
  },

  updateQuestion: async (eventId, questionId, questionData) => {
    try {
      const response = await AdminAxiosInstance.patch(`/events/${eventId}/questions/${questionId}`, questionData)
      return { response }
    } catch (error) {
      /* empty */
    }
  },

  closeEvent: async (eventId) => {
    try {
      const response = await AdminAxiosInstance.patch(`/events/${eventId}/close`)
      return { response }
    } catch (error) {
      /* empty */
    }
  },

  deleteQuestion: async (eventId, questionId) => {
    try {
      const response = await AdminAxiosInstance.delete(`/events/${eventId}/questions/${questionId}`)
      return { response }
    } catch (error) {
      /* empty */
    }
  },
  uploadVoters: async (eventId, formData) => {
    try {
      const res: any = await AdminAxiosInstance.patch(`/events/${eventId}/upload-voters`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return { numUsers: res?.numUsers, users: res?.users }
    } catch (error) {
      /* empty */
    }
  },
  deleteVoter: async (eventId, voterId) => {
    try {
      const res: any = await AdminAxiosInstance.delete(`/events/${eventId}/voters/${voterId}`)
      return res?.success
    } catch (error) {
      /* empty */
    }
  },
  sendInvitation: async (eventId, voterId) => {
    try {
      const res: any = await AdminAxiosInstance.post(`/events/${eventId}/voters/${voterId}/send-invitation`)
      return res?.success
    } catch (error) {
      /* empty */
    }
  },
  getVotingDetails: async (eventId, questionId) => {
    try {
      const res: any = await AdminAxiosInstance.get(`/events/${eventId}/questions/${questionId}/voting-details`)
      return { votingDetails: res?.votingDetails, results: res?.results }
    } catch (error) {
      /* empty */
    }
  },
}

export default AdminInstantMeetingService
